import { NavLink } from 'react-router-dom'
import confirmDelete from 'shared/utils/confirmDelete'
import * as Icon from 'react-bootstrap-icons'
import getAll from 'utils/getAll'
import { apiUrls, roles } from 'consts'
import { formatDateTime, stringToDate } from 'utils/dateUtils'
import hasAnyRole from 'shared/utils/hasAnyRole'

interface getRowsProps {
  deviceId: string
  setDeleteEntryId: Function
  setShowModal: Function
}

const getRows = async (props: getRowsProps) => {
  let data = await getAll(apiUrls.comments + '?id=' + props.deviceId)

  const canDeleteByRole = hasAnyRole([roles.admin, roles.superAdmin])

  data.forEach((row: any, index: number, dataArray: any) => {
    const canDeleteComment: boolean = dataArray[index].system !== 1
    dataArray[index].action = (
      <>
        {canDeleteByRole && canDeleteComment && (
          <NavLink
            to={'/delete-comment/' + row.id}
            className='danger'
            onClick={(e) =>
              confirmDelete({
                e,
                id: dataArray[index].id,
                setDeleteEntryId: props.setDeleteEntryId,
                setShowModal: props.setShowModal,
              })
            }
          >
            <Icon.Trash height='0.9em' width='0.9em' /> Delete
          </NavLink>
        )}
      </>
    )

    const date: Date | null = stringToDate(dataArray[index].date)
    dataArray[index].date = formatDateTime(date)
    dataArray[index].user = dataArray[index].user?.concatened
  })

  return data
}

export default getRows
